<form [formGroup]="fileSection">
  <div class="file-attachment-container">
    <label>Source entity</label>
    @if (!hasOnlyOneAvailableSourceEntity) {
      <app-attachment-source-picker
        (selected)="selected($event)"
        [templateEntity]="templateEntity"
        [alreadySelectedPaths]="alreadySelectedPaths"
        >
      </app-attachment-source-picker>
    }

    <div class="chips-container inline-chips">
      @for (sourceOption of sourceOptions$ | async; track sourceOption) {
        <button class="chip">
          {{ sourceOption.label }}
          @if (!hasOnlyOneAvailableSourceEntity) {
            <mat-icon
              fontIcon="close"
              class="remove-chip"
              matTooltip="Remove {{ sourceOption.label }}"
              matTooltipShowDelay="500"
              (click)="onRemove(sourceOption)"
            ></mat-icon>
          }
        </button>
      }
    </div>
  </div>
</form>
